import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { SiteHeader } from "../site/SiteHeader";
import { MobileBottomBar } from "../site/MobileBottomBar";

export const ProfileShell = ({ title, children, rightSlot = null }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a1119] text-white pb-24 lg:pb-10">
      <div className="hidden lg:block">
        <SiteHeader />
      </div>
      <div className="lg:hidden sticky top-0 z-30 bg-[#0a1119]/95 backdrop-blur border-b border-white/5">
        <div className="flex items-center justify-between gap-2 px-2 h-14">
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="back"
            data-testid="profile-back"
            className="h-10 w-10 rounded-full flex items-center justify-center text-white/85 hover:text-white hover:bg-white/5"
          >
            <ChevronLeft size={24} />
          </button>
          <h1
            className="text-lg font-bold tracking-tight flex-1 text-center truncate"
            data-testid="profile-sub-title"
          >
            {title}
          </h1>
          <div className="w-10 flex items-center justify-end">{rightSlot}</div>
        </div>
      </div>
      <div className="max-w-2xl mx-auto px-4 pt-4">{children}</div>
      <div className="lg:hidden">
        <MobileBottomBar onMenuClick={() => navigate("/")} />
      </div>
    </div>
  );
};
